import { Map } from 'immutable';
import { Homework } from './';

import {
  FETCH_HOMEWORK_SUCCESS,
  PUBLISH_HOMEWORK_SUCCESS,
  CLEAR_HOMEWORK_SUCCESS,
} from './actions';
import {
  ASSIGN_HOMEWORK_SUCCESS,
} from './Content/actions';

export default function homeworkReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_HOMEWORK_SUCCESS:
      return addHomeworkToMap(state, action);
    case PUBLISH_HOMEWORK_SUCCESS:
      return updateHomeworkStatus(state, action.sessionId, Homework.Status.PUBLISHED);
    case ASSIGN_HOMEWORK_SUCCESS:
      return updateHomeworkStatus(state, action.sessionId, Homework.Status.UPDATED);
    case CLEAR_HOMEWORK_SUCCESS:
      return updateHomeworkStatus(state, action.sessionId, Homework.Status.NEW);
    default:
      return state;
  }
}

function updateHomeworkStatus(state, sessionId, status) {
  return state.update(`${sessionId}`, (homework) =>
      homework.set('homeworkResultStatus', status));
}

function addHomeworkToMap(state, { payload }) {
  const { homeworkResultStatus, sessionId } = payload;
  return state.set(`${sessionId}`, new Homework({ homeworkResultStatus, sessionId }));
}



// WEBPACK FOOTER //
// ./data/Homework/reducer.js